{
  "it": {
    "directUpload": {
      "title": "Carica",
      "chooseFiles": "Scegli file",
      "dropzone": {
        "textMultiple": "Trascina i file qui per caricare",
        "textDirectory": "Trascina qui una cartella",
        "text": "Trascina il file qui per caricare",
        "or": "o",
        "browse": "sfoglia",
        "browseDirectory": "scegli una cartella"
      },
      "previewImage": {
        "remove": "Rimuovi"
      },
      "actions": {
        "upload": "Carica",
        "close": "Chiudi"
      }
    }
  }
}
